<app-segov-sigepo-portal-body>
  <app-segov-sigepo-header-section [Title]="title"
    [RouteStack]="RouteStack">
  </app-segov-sigepo-header-section>

  <div class="grupo-colunas-glossario">

    <h1 style="font-weight: 600; color: var(--tom-2-informativo)"><img width="48px" src="icons/book-shelf-line.svg" alt="Ícone de Livros"/>Glossário</h1>
    <h5 style="max-width: 100vh; font-weight: 400;">Conheça os termos técnicos e palavras que fazem parte do conteúdo do Jornal Minas Gerais</h5>

    <div>
      @if(errorMsg){
        <p class="error-message text-center mt-2">{{errorMsg}}</p>
      }
      <div style="text-align: right;">
        <span style="text-decoration: underline; color: var(--tom-2-informativo); cursor: pointer; width: fit-content; text-align: right;"
      tabindex="0" (click)="toggleAccordions()" (keyup.enter)="toggleAccordions()">Ver todos</span>
      </div>
      <div style="width: 100%; margin-bottom: 3rem; ">
        @for (grupoLetra of GlossariosOutputDto; track grupoLetra) {
          <lib-segov-sigepo-accordeon
          [customTitleStyle]="'padding-left: 1rem; font-weight: 600; color: var(--tom-2-informativo);'"
          [customChevronStyle]="'font-size: 24px; color: var(--tom-2-informativo);'"
          [isExpanded]="exibeConteudoAccordions"
          [title]="grupoLetra.letraInicial">
             @for (termo of grupoLetra.termosTecnicos; track termo) {
              <p><strong>{{ termo.termoTecnico }}:</strong> {{ termo.descricao}}</p>
             }
          </lib-segov-sigepo-accordeon>
        }
      </div>
    </div>
  </div>
</app-segov-sigepo-portal-body>
